import * as React from 'react';
import { Close } from '@liveauctioneers/hammer-ui-core/icons';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { FormattedMessage, FormattedNumber } from '@liveauctioneers/hammer-ui-core/intl';
import { getSellerName } from '@/redux/modules/seller';
import { getSellerUpcomingCatalogCount } from '@/redux/modules/sellerCatalogCounts';
import { getSellerUrl } from '@/utils/urls';
import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { safelyRender } from '@/utils/safelyRender';
import { submitUnfollowSeller } from '@/redux/modules/followSeller';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useTrackAuctioneerUnfollowedAnalytics } from '@/utils/amplitude/analytics';

type Props = {
    className?: string;
    sellerId: number;
};

const SellerTableRow = ({ className, sellerId }: Props) => {
    const dispatch = useAppDispatch();
    const trackAuctioneerUnfollowed = useTrackAuctioneerUnfollowedAnalytics();

    const name = useAppSelector((state) => getSellerName(state, sellerId));
    const upcomingCount = useAppSelector((state) => getSellerUpcomingCatalogCount(state, sellerId));

    return (
        <tr
            className={cn(className, 'h-[60px]')}
            key={sellerId}
        >
            <td>
                <Link
                    href={getSellerUrl(sellerId, name)}
                    size="sm"
                >
                    {safelyRender({ html: name, wrapper: '' })}
                </Link>
            </td>
            <td className="xsMax:hidden">
                {upcomingCount === 0 ? (
                    <FormattedMessage id="no_upcoming" />
                ) : (
                    <FormattedNumber
                        key="seller-table-upcoming-count"
                        maximumFractionDigits={0}
                        minimumFractionDigits={0}
                        value={upcomingCount}
                    />
                )}
            </td>
            <td className="w-[10%] pr-md text-right">
                <IconButton
                    icon={Close}
                    onClick={() => {
                        dispatch(submitUnfollowSeller(sellerId));
                        trackAuctioneerUnfollowed();
                    }}
                    size="sm"
                />
            </td>
        </tr>
    );
};

export default SellerTableRow;
